<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">ADMINISTRAR CAUSAS DEL PROBLEMA</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
                <modal-ayuda></modal-ayuda>
                <v-btn color="green" fab small dark @click="crear">
                    <v-icon>add</v-icon>
                </v-btn>
            </v-card-text>
            <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
        </v-card>

        <data-table class="mt-5" @editar="editar($event)"></data-table>

        <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import ModalAyudas from '../../components/shared/ModalAyudas.vue';
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        inputs:[
            {tipo:'texto',valor:'',label:'Causa del Problema*',key:'causa'},
            {tipo:'switch',valor:1,label:'Activo*',key:'activo'}
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
                {
                    text:'Causa del Problema',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    value:'causa',
                    class:'cabecera'
                },
                {
                    text: 'Activo',
                    align: 'center',
                    sortable: true,
                    value: 'activo_texto',
                    class:'cabecera'
                },
                { text: 'Acciones', value: 'action', sortable: false, align:'center', class:'cabecera' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    mounted() {
        this.cargarDatos();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Administrar Causas del Problema`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestran y modifican las causas de problemas en las inspecciones.`},
                {   tipo:`label`,   texto:`- Para añadir una nueva causa, se pulsa el botón "+" y se rellenan los campos requeridos (la causa y si está activa). Finalmente, se pulsa el botón "Crear".`},
                {   tipo:`label`,   texto:`- En la tabla se muestra la causa del problema y si está activa o no.`},
                {   tipo:`label`,   texto:`- En la columna Acciones, al pulsar el botón de un área, se abrirá una ventana con los campos de esa causa para poder modificarlos (la causa y si está activa o no). Al finalizar la edición, se debe pulsar en "Actualizar"`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}pac_causa`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                // Event.$emit('actualizar_lista',this.lista);
                // Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Causa del Problema';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'pac_causa';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.inputs[1].valor = 1;
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Causa del Problema';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `pac_causa/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
        'modal-ayuda': ModalAyudas,
    }
}
</script>